import classNames from "classnames";
import { PropsWithChildren } from "react";

type DropdownMenuItemTextProps = {
  "data-testid"?: string;
  className?: string;
};

export const DropdownMenuItemText = ({
  children,
  className: additionalClasses,
  "data-testid": dataTestId,
}: PropsWithChildren<DropdownMenuItemTextProps>) => {
  return (
    <div
      data-testid={dataTestId ?? "dropdown-menu-item-text"}
      className={classNames("rounded-sm", "cursor-default", "p-2", "m-2", additionalClasses)}
    >
      {children}
    </div>
  );
};
